import React, { FC } from 'react';
import styled from 'styled-components';

import { Box, Image } from '@rover/kibble/core';
import { Color } from '@rover/kibble/styles';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';

// this is needed to avoid extra space rendered below the image
const StyledImage = styled(Image)`
  vertical-align: top;
`;

const Avatar: FC = () => {
  const { user } = useCurrentUserShim();
  const { smallPhotoUrl } = user || {};

  if (!smallPhotoUrl) return null;
  return (
    <Box border={`1px solid ${Color.NEUTRAL_WHITE.toString()}`}>
      <StyledImage width="24" height="24" src={smallPhotoUrl} description="" />
    </Box>
  );
};

export default Avatar;
